/* ═══════════════════════════════════════════════════
   AQM DASHBOARD — Comprehensive Dummy Data
   Covers: Indoor AQM + Outdoor/Ambient AQM
═══════════════════════════════════════════════════ */

export const aqmDummyData = {

  /* ─────────────────────── INDOOR ─────────────────────── */
  indoor: {
    site: {
      name: "IoTMATE Corporate HQ",
      location: "Hinjewadi Phase 2, Pune, Maharashtra",
      type: "Office Building",
      floors: 3,
      totalRooms: 15,
      totalDevices: 22,
      onlineDevices: 20,
    },

    summary: {
      overallAqi: 87,
      aqiCategory: "Moderate",
      pm25: 38.4,
      pm10: 62.1,
      co2: 924,
      tvoc: 0.38,
      temperature: 24.8,
      humidity: 59,
      activeAlerts: 4,
      criticalAlerts: 1,
    },

    floors: [
      {
        id: "F1",
        name: "Ground Floor",
        label: "GF",
        overallAqi: 74,
        rooms: [
          { id: "R101", name: "Lobby",         aqi: 55, co2: 480,  tvoc: 0.14, pm25: 18.2, pm10: 28.4, temp: 23.2, hum: 52, noise: 61, deviceId: "AQM-001", status: "Online",  lastSeen: "1 min ago", x: 2,  y: 2,  w: 28, h: 44 },
          { id: "R102", name: "Reception",     aqi: 72, co2: 670,  tvoc: 0.22, pm25: 26.5, pm10: 44.2, temp: 24.5, hum: 57, noise: 58, deviceId: "AQM-002", status: "Online",  lastSeen: "2 min ago", x: 32, y: 2,  w: 28, h: 44 },
          { id: "R103", name: "Cafeteria",     aqi: 98, co2: 1050, tvoc: 0.45, pm25: 42.1, pm10: 74.5, temp: 27.2, hum: 68, noise: 72, deviceId: "AQM-003", status: "Online",  lastSeen: "1 min ago", x: 62, y: 2,  w: 36, h: 44 },
          { id: "R104", name: "Server Room",   aqi: 44, co2: 380,  tvoc: 0.08, pm25: 12.1, pm10: 18.5, temp: 19.5, hum: 42, noise: 48, deviceId: "AQM-004", status: "Online",  lastSeen: "3 min ago", x: 2,  y: 52, w: 28, h: 42 },
          { id: "R105", name: "Meeting R. 1",  aqi: 81, co2: 860,  tvoc: 0.32, pm25: 32.4, pm10: 56.1, temp: 24.8, hum: 60, noise: 45, deviceId: "AQM-005", status: "Online",  lastSeen: "1 min ago", x: 32, y: 52, w: 28, h: 42 },
          { id: "R106", name: "Storage",       aqi: 35, co2: 320,  tvoc: 0.06, pm25: 10.5, pm10: 16.2, temp: 22.1, hum: 48, noise: 32, deviceId: "AQM-006", status: "Offline", lastSeen: "14 min ago",x: 62, y: 52, w: 36, h: 42 },
        ],
      },
      {
        id: "F2",
        name: "First Floor",
        label: "1F",
        overallAqi: 104,
        rooms: [
          { id: "R201", name: "Open Office A",  aqi: 96,  co2: 1020, tvoc: 0.42, pm25: 40.2, pm10: 68.5, temp: 25.1, hum: 62, noise: 55, deviceId: "AQM-007", status: "Online",  lastSeen: "1 min ago", x: 2,  y: 2,  w: 44, h: 44 },
          { id: "R202", name: "Open Office B",  aqi: 112, co2: 1180, tvoc: 0.52, pm25: 48.5, pm10: 82.1, temp: 25.8, hum: 64, noise: 58, deviceId: "AQM-008", status: "Online",  lastSeen: "2 min ago", x: 48, y: 2,  w: 50, h: 44 },
          { id: "R203", name: "Meeting R. 2",   aqi: 88,  co2: 890,  tvoc: 0.35, pm25: 35.6, pm10: 60.2, temp: 24.2, hum: 58, noise: 42, deviceId: "AQM-009", status: "Online",  lastSeen: "1 min ago", x: 2,  y: 52, w: 28, h: 42 },
          { id: "R204", name: "Meeting R. 3",   aqi: 138, co2: 1420, tvoc: 0.68, pm25: 62.4, pm10: 105.2,temp: 26.5, hum: 72, noise: 65, deviceId: "AQM-010", status: "Online",  lastSeen: "1 min ago", x: 32, y: 52, w: 28, h: 42 },
          { id: "R205", name: "Pantry",         aqi: 75,  co2: 640,  tvoc: 0.28, pm25: 28.4, pm10: 48.2, temp: 26.1, hum: 66, noise: 52, deviceId: "AQM-011", status: "Online",  lastSeen: "4 min ago", x: 62, y: 52, w: 36, h: 42 },
        ],
      },
      {
        id: "F3",
        name: "Second Floor",
        label: "2F",
        overallAqi: 62,
        rooms: [
          { id: "R301", name: "Executive Suite", aqi: 48, co2: 420,  tvoc: 0.15, pm25: 16.4, pm10: 26.5, temp: 23.5, hum: 54, noise: 38, deviceId: "AQM-012", status: "Online",  lastSeen: "2 min ago", x: 2,  y: 2,  w: 44, h: 44 },
          { id: "R302", name: "Boardroom",       aqi: 65, co2: 580,  tvoc: 0.20, pm25: 22.8, pm10: 38.4, temp: 23.8, hum: 55, noise: 36, deviceId: "AQM-013", status: "Online",  lastSeen: "1 min ago", x: 48, y: 2,  w: 50, h: 44 },
          { id: "R303", name: "HR Office",       aqi: 70, co2: 620,  tvoc: 0.22, pm25: 25.2, pm10: 42.1, temp: 24.1, hum: 56, noise: 44, deviceId: "AQM-014", status: "Online",  lastSeen: "3 min ago", x: 2,  y: 52, w: 44, h: 42 },
          { id: "R304", name: "Terrace Lounge",  aqi: 58, co2: 420,  tvoc: 0.18, pm25: 21.5, pm10: 36.2, temp: 29.5, hum: 62, noise: 55, deviceId: "AQM-015", status: "Offline", lastSeen: "22 min ago",x: 48, y: 52, w: 50, h: 42 },
        ],
      },
    ],

    hvac: {
      mode: "Auto",
      totalFreshAirflow: 4850,
      energySavingPct: 18,
      zones: [
        { id: "Z1", name: "Lobby & Reception",  floor: "GF", co2: 580,  damperPct: 55, fanSpeed: "Medium", ahuStatus: "Running", trigger: "Scheduled",      airflow: 820  },
        { id: "Z2", name: "Cafeteria",          floor: "GF", co2: 1050, damperPct: 85, fanSpeed: "High",   ahuStatus: "Running", trigger: "CO₂ > 900 ppm",  airflow: 1240 },
        { id: "Z3", name: "Open Office A & B",  floor: "1F", co2: 1100, damperPct: 90, fanSpeed: "High",   ahuStatus: "Running", trigger: "CO₂ > 1000 ppm", airflow: 1450 },
        { id: "Z4", name: "Meeting Rooms 2 & 3",floor: "1F", co2: 1155, damperPct: 95, fanSpeed: "High",   ahuStatus: "Running", trigger: "CO₂ CRITICAL",   airflow: 680  },
        { id: "Z5", name: "Executive Floor",    floor: "2F", co2: 500,  damperPct: 30, fanSpeed: "Low",    ahuStatus: "Standby", trigger: "Normal",         airflow: 360  },
        { id: "Z6", name: "Server Room",        floor: "GF", co2: 380,  damperPct: 20, fanSpeed: "Low",    ahuStatus: "Running", trigger: "Temperature",    airflow: 300  },
      ],
      coThreshold: 800,
      co2AutoTrigger: true,
      exhaustFanStatus: "Running",
    },

    hourlyTrend: [
      { t: "00:00", aqi: 42, co2: 380, pm25: 14, tvoc: 0.12 },
      { t: "01:00", aqi: 38, co2: 360, pm25: 12, tvoc: 0.10 },
      { t: "02:00", aqi: 35, co2: 340, pm25: 11, tvoc: 0.09 },
      { t: "03:00", aqi: 33, co2: 320, pm25: 10, tvoc: 0.09 },
      { t: "04:00", aqi: 36, co2: 335, pm25: 12, tvoc: 0.10 },
      { t: "05:00", aqi: 44, co2: 380, pm25: 15, tvoc: 0.13 },
      { t: "06:00", aqi: 52, co2: 440, pm25: 20, tvoc: 0.18 },
      { t: "07:00", aqi: 68, co2: 580, pm25: 26, tvoc: 0.24 },
      { t: "08:00", aqi: 82, co2: 720, pm25: 34, tvoc: 0.31 },
      { t: "09:00", aqi: 95, co2: 920, pm25: 41, tvoc: 0.38 },
      { t: "10:00", aqi: 104, co2: 1050, pm25: 46, tvoc: 0.44 },
      { t: "11:00", aqi: 112, co2: 1150, pm25: 50, tvoc: 0.48 },
      { t: "12:00", aqi: 118, co2: 1220, pm25: 54, tvoc: 0.52 },
      { t: "13:00", aqi: 125, co2: 1280, pm25: 58, tvoc: 0.55 },
      { t: "14:00", aqi: 132, co2: 1350, pm25: 62, tvoc: 0.58 },
      { t: "15:00", aqi: 138, co2: 1420, pm25: 64, tvoc: 0.61 },
      { t: "16:00", aqi: 128, co2: 1300, pm25: 58, tvoc: 0.56 },
      { t: "17:00", aqi: 110, co2: 1120, pm25: 50, tvoc: 0.48 },
      { t: "18:00", aqi: 88, co2: 880, pm25: 38, tvoc: 0.35 },
      { t: "19:00", aqi: 72, co2: 680, pm25: 28, tvoc: 0.26 },
      { t: "20:00", aqi: 58, co2: 520, pm25: 22, tvoc: 0.19 },
      { t: "21:00", aqi: 50, co2: 440, pm25: 18, tvoc: 0.15 },
      { t: "22:00", aqi: 45, co2: 400, pm25: 15, tvoc: 0.13 },
      { t: "23:00", aqi: 42, co2: 375, pm25: 14, tvoc: 0.12 },
    ],

    weeklyAqi: [
      { day: "Mon", aqi: 92 }, { day: "Tue", aqi: 85 }, { day: "Wed", aqi: 110 },
      { day: "Thu", aqi: 78 }, { day: "Fri", aqi: 125 }, { day: "Sat", aqi: 58 },
      { day: "Sun", aqi: 45 },
    ],

    alerts: [
      { id: "IA-001", severity: "Critical", category: "CO₂", room: "Meeting Room 3 (R204)", message: "CO₂ level 1420 ppm — exceeds 1200 ppm threshold. Immediate ventilation required.", time: "10 min ago", ack: false, assignedTo: null },
      { id: "IA-002", severity: "Warning",  category: "TVOC", room: "Open Office B (R202)", message: "TVOC at 0.52 mg/m³ — elevated. Check for cleaning chemical usage.", time: "28 min ago", ack: false, assignedTo: "Maintenance" },
      { id: "IA-003", severity: "Warning",  category: "PM2.5", room: "Meeting Room 3 (R204)", message: "PM2.5 at 62.4 µg/m³ — above 60 µg/m³ threshold.", time: "35 min ago", ack: false, assignedTo: null },
      { id: "IA-004", severity: "Info",     category: "Device", room: "Storage (R106)", message: "AQM-006 offline since 14 minutes. Check device power.", time: "14 min ago", ack: true,  assignedTo: "IT Team" },
      { id: "IA-005", severity: "Info",     category: "Device", room: "Terrace Lounge (R304)", message: "AQM-015 offline — outdoor exposure may have caused reset.", time: "22 min ago", ack: false, assignedTo: null },
    ],

    aiInsights: [
      { id: "AI-IN-01", priority: "High",   icon: "🫁", title: "Meeting Room 3 — Severe CO₂ Spike", insight: "CO₂ at 1420 ppm every weekday 14:00–16:00, correlating with 8-person meetings. Recommend automatic ventilation trigger when occupancy > 6.", action: "Auto-Trigger" },
      { id: "AI-IN-02", priority: "High",   icon: "🌬", title: "Open Office B — Poor Air Quality Pattern", insight: "AQI consistently above 100 during 10:00–17:00. Zone Z3 fan should increase to High during this window. Estimated CO₂ reduction: 18%.", action: "Adjust HVAC" },
      { id: "AI-IN-03", priority: "Medium", icon: "💡", title: "HVAC Energy Optimization", insight: "Executive floor HVAC running at 30% damper all day with low CO₂ (380–500 ppm). Reduce to 15% during non-peak hours to save ~₹240/day.", action: "Optimize" },
      { id: "AI-IN-04", priority: "Medium", icon: "🧪", title: "Cafeteria PM2.5 Spike at Lunch", insight: "PM2.5 spikes to 55–65 µg/m³ daily between 12:30–14:00. Likely cooking-related. Activate exhaust fan at 12:15 proactively.", action: "Schedule" },
      { id: "AI-IN-05", priority: "Low",    icon: "📅", title: "Calibration Due", insight: "AQM-003, AQM-010 last calibrated 82 days ago. Calibration interval is 90 days. Schedule within next 8 days.", action: "Schedule" },
    ],

    reports: [
      { id: "IR-01", name: "Indoor Air Quality Daily Report",   desc: "Full room-wise AQI, CO₂, TVOC, PM2.5 summary",  generated: "Today 06:00",  formats: ["PDF","CSV","Excel"] },
      { id: "IR-02", name: "HVAC Performance Report",           desc: "Zone-wise damper, fan speed, energy consumption", generated: "Today 06:00",  formats: ["PDF","CSV"]        },
      { id: "IR-03", name: "CO₂ Trend Analysis",               desc: "Hourly CO₂ by room with occupancy correlation",  generated: "Yesterday",    formats: ["PDF","Excel"]      },
      { id: "IR-04", name: "Weekly Indoor Health Summary",      desc: "7-day AQI trend, compliance status, alerts log",  generated: "Mon 06:00",    formats: ["PDF","CSV","Excel"] },
      { id: "IR-05", name: "Device Health Report",              desc: "Device online/offline status, calibration dates", generated: "Yesterday",    formats: ["PDF","CSV"]        },
      { id: "IR-06", name: "Monthly Indoor AQM Compliance",    desc: "Monthly averages vs health standard limits",      generated: "01 Feb 2026",  formats: ["PDF","Excel"]      },
    ],
  },

  /* ─────────────────────── OUTDOOR ─────────────────────── */
  outdoor: {
    site: {
      name: "Pune City AQM Network",
      location: "Pune, Maharashtra",
      type: "Urban Ambient",
      operator: "Pune Municipal Corporation + IoTMATE",
      totalStations: 6,
      onlineStations: 5,
    },

    summary: {
      overallAqi: 148,
      aqiCategory: "Unhealthy for Sensitive",
      pm25: 72.4,
      pm10: 138.5,
      so2: 22.8,
      no2: 48.5,
      co: 1.8,
      o3: 42.5,
      temperature: 32.4,
      humidity: 62,
      windSpeed: 14.5,
      windDirection: "SW",
      windDegrees: 225,
      activeAlerts: 5,
    },

    stations: [
      {
        id: "S01", name: "Industrial Zone North", type: "Industrial", shortName: "IND-N",
        x: 22, y: 14,
        aqi: 218, aqiCategory: "Very Unhealthy",
        pm25: 128.4, pm10: 242.5, so2: 52.4, no2: 88.2, co: 3.2, o3: 28.5,
        temperature: 33.8, humidity: 55, windSpeed: 9.2, windDir: "SW",
        status: "Online", lastSeen: "2 min ago",
      },
      {
        id: "S02", name: "Residential — Aundh", type: "Residential", shortName: "RES",
        x: 48, y: 28,
        aqi: 112, aqiCategory: "Unhealthy for Sensitive",
        pm25: 58.2, pm10: 108.4, so2: 12.5, no2: 38.4, co: 1.2, o3: 45.2,
        temperature: 31.5, humidity: 64, windSpeed: 12.5, windDir: "W",
        status: "Online", lastSeen: "1 min ago",
      },
      {
        id: "S03", name: "Commercial Hub — FC Road", type: "Commercial", shortName: "COM",
        x: 58, y: 52,
        aqi: 165, aqiCategory: "Unhealthy",
        pm25: 84.5, pm10: 162.8, so2: 28.4, no2: 62.1, co: 2.1, o3: 38.5,
        temperature: 33.2, humidity: 60, windSpeed: 8.5, windDir: "SW",
        status: "Online", lastSeen: "3 min ago",
      },
      {
        id: "S04", name: "Highway Junction — NH-48", type: "Traffic", shortName: "HWY",
        x: 82, y: 64,
        aqi: 195, aqiCategory: "Unhealthy",
        pm25: 105.2, pm10: 198.4, so2: 18.5, no2: 95.4, co: 3.8, o3: 22.5,
        temperature: 34.5, humidity: 58, windSpeed: 18.5, windDir: "SE",
        status: "Online", lastSeen: "1 min ago",
      },
      {
        id: "S05", name: "Green Belt — Empress Garden", type: "Green Zone", shortName: "GRN",
        x: 35, y: 70,
        aqi: 58, aqiCategory: "Moderate",
        pm25: 22.1, pm10: 42.5, so2: 5.2, no2: 18.4, co: 0.5, o3: 55.4,
        temperature: 29.8, humidity: 72, windSpeed: 10.5, windDir: "W",
        status: "Online", lastSeen: "4 min ago",
      },
      {
        id: "S06", name: "School Zone — Kothrud", type: "Sensitive Zone", shortName: "SCH",
        x: 18, y: 58,
        aqi: 128, aqiCategory: "Unhealthy for Sensitive",
        pm25: 64.5, pm10: 122.8, so2: 14.2, no2: 42.8, co: 1.4, o3: 48.5,
        temperature: 31.8, humidity: 63, windSpeed: 11.5, windDir: "SW",
        status: "Offline", lastSeen: "38 min ago",
      },
    ],

    weather: {
      temp: 32.4, humidity: 62, windSpeed: 14.5, windDir: "SW", windDeg: 225,
      pressure: 1008, uvIndex: 8, visibility: 6.5,
      forecast: [
        { day: "Tomorrow",  aqi: 155, condition: "Partly Cloudy", windSpeed: 12, windDir: "SW" },
        { day: "Fri",       aqi: 140, condition: "Cloudy",        windSpeed: 16, windDir: "W"  },
        { day: "Sat",       aqi: 105, condition: "Light Rain",    windSpeed: 20, windDir: "NW" },
        { day: "Sun",       aqi: 75,  condition: "Rainy",         windSpeed: 22, windDir: "N"  },
        { day: "Mon",       aqi: 85,  condition: "Partly Cloudy", windSpeed: 14, windDir: "NE" },
      ],
    },

    compliance: {
      authority: "CPCB (Central Pollution Control Board)",
      standard: "NAAQS 2009",
      permitId: "CPCB/MH/2024-0458",
      lastAuditDate: "15 Jan 2026",
      nextAuditDate: "15 Apr 2026",
      limits: {
        pm25_24h: 60,  pm25_annual: 40,
        pm10_24h: 100, pm10_annual: 60,
        so2_24h: 80,   so2_annual: 50,
        no2_24h: 80,   no2_annual: 40,
        co_8h: 2,      o3_8h: 100,
      },
      currentAverages: {
        pm25: 72.4, pm10: 138.5, so2: 22.8, no2: 48.5, co: 1.8, o3: 42.5,
      },
      violations: 3,
      dailyLog: [
        { date: "27 Feb 2026", pm25: 72.4, pm10: 138.5, so2: 22.8, no2: 48.5, co: 1.8, o3: 42.5, compliant: false },
        { date: "26 Feb 2026", pm25: 64.2, pm10: 120.5, so2: 18.5, no2: 42.2, co: 1.5, o3: 45.2, compliant: false },
        { date: "25 Feb 2026", pm25: 55.8, pm10: 98.4,  so2: 14.2, no2: 36.5, co: 1.2, o3: 52.4, compliant: true  },
        { date: "24 Feb 2026", pm25: 48.5, pm10: 88.2,  so2: 12.5, no2: 32.5, co: 1.0, o3: 58.2, compliant: true  },
        { date: "23 Feb 2026", pm25: 80.2, pm10: 152.4, so2: 28.5, no2: 56.4, co: 2.2, o3: 35.5, compliant: false },
        { date: "22 Feb 2026", pm25: 58.5, pm10: 105.2, so2: 16.5, no2: 40.2, co: 1.4, o3: 48.5, compliant: true  },
        { date: "21 Feb 2026", pm25: 42.5, pm10: 78.5,  so2: 10.5, no2: 28.5, co: 0.9, o3: 62.5, compliant: true  },
      ],
      violationHistory: [
        { date: "27 Feb 2026", parameter: "PM2.5 (24h)",  value: "72.4 µg/m³", limit: "60 µg/m³",  station: "Industrial Zone",  action: "Alert sent to CPCB portal" },
        { date: "26 Feb 2026", parameter: "PM10 (24h)",   value: "120.5 µg/m³",limit: "100 µg/m³", station: "Commercial Hub",    action: "Monitoring increased" },
        { date: "23 Feb 2026", parameter: "PM2.5 (24h)",  value: "80.2 µg/m³", limit: "60 µg/m³",  station: "Industrial Zone",  action: "Industry notified" },
      ],
    },

    pollutionAnalysis: {
      primarySources: [
        { source: "Vehicular Emissions", contribution: 38, color: "#ef4444" },
        { source: "Industrial",          contribution: 28, color: "#f97316" },
        { source: "Construction Dust",   contribution: 18, color: "#f59e0b" },
        { source: "Road Dust",           contribution: 10, color: "#eab308" },
        { source: "Other",               contribution: 6,  color: "#6b7280" },
      ],
      windCorrelation: [
        { windDir: "SW", aqiAvg: 185, note: "Industrial zone upwind" },
        { windDir: "W",  aqiAvg: 148, note: "Mixed residential" },
        { windDir: "NW", aqiAvg: 95,  note: "Cleaner air" },
        { windDir: "N",  aqiAvg: 82,  note: "Cleaner air" },
        { windDir: "NE", aqiAvg: 110, note: "Highway traffic" },
        { windDir: "E",  aqiAvg: 135, note: "Commercial zone" },
        { windDir: "SE", aqiAvg: 168, note: "Highway junction" },
        { windDir: "S",  aqiAvg: 142, note: "Mixed" },
      ],
    },

    hourlyTrend: [
      { t: "00:00", aqi: 95,  pm25: 42, pm10: 82,  no2: 28 },
      { t: "01:00", aqi: 88,  pm25: 38, pm10: 72,  no2: 24 },
      { t: "02:00", aqi: 82,  pm25: 34, pm10: 66,  no2: 22 },
      { t: "03:00", aqi: 78,  pm25: 32, pm10: 62,  no2: 20 },
      { t: "04:00", aqi: 84,  pm25: 35, pm10: 68,  no2: 22 },
      { t: "05:00", aqi: 98,  pm25: 44, pm10: 84,  no2: 28 },
      { t: "06:00", aqi: 115, pm25: 55, pm10: 102, no2: 38 },
      { t: "07:00", aqi: 142, pm25: 70, pm10: 132, no2: 52 },
      { t: "08:00", aqi: 168, pm25: 88, pm10: 162, no2: 68 },
      { t: "09:00", aqi: 175, pm25: 92, pm10: 172, no2: 75 },
      { t: "10:00", aqi: 165, pm25: 85, pm10: 158, no2: 68 },
      { t: "11:00", aqi: 152, pm25: 78, pm10: 145, no2: 58 },
      { t: "12:00", aqi: 148, pm25: 72, pm10: 138, no2: 52 },
      { t: "13:00", aqi: 155, pm25: 80, pm10: 148, no2: 55 },
      { t: "14:00", aqi: 162, pm25: 84, pm10: 158, no2: 60 },
      { t: "15:00", aqi: 170, pm25: 90, pm10: 168, no2: 65 },
      { t: "16:00", aqi: 178, pm25: 95, pm10: 178, no2: 72 },
      { t: "17:00", aqi: 185, pm25: 100,pm10: 192, no2: 82 },
      { t: "18:00", aqi: 172, pm25: 90, pm10: 172, no2: 70 },
      { t: "19:00", aqi: 158, pm25: 80, pm10: 152, no2: 58 },
      { t: "20:00", aqi: 142, pm25: 70, pm10: 132, no2: 48 },
      { t: "21:00", aqi: 128, pm25: 62, pm10: 118, no2: 40 },
      { t: "22:00", aqi: 112, pm25: 54, pm10: 102, no2: 34 },
      { t: "23:00", aqi: 98,  pm25: 46, pm10: 88,  no2: 28 },
    ],

    weeklyAqi: [
      { day: "Mon", aqi: 145 }, { day: "Tue", aqi: 158 }, { day: "Wed", aqi: 132 },
      { day: "Thu", aqi: 168 }, { day: "Fri", aqi: 185 }, { day: "Sat", aqi: 112 },
      { day: "Sun", aqi: 88  },
    ],

    alerts: [
      { id: "OA-001", severity: "Critical", category: "PM2.5",   station: "Industrial Zone North", message: "PM2.5 at 128.4 µg/m³ — exceeds CPCB 24h limit of 60 µg/m³. Very Unhealthy AQI 218.", time: "5 min ago",  ack: false, assignedTo: null },
      { id: "OA-002", severity: "Critical", category: "PM10",    station: "Highway Junction NH-48",  message: "PM10 at 198.4 µg/m³ — 98% of CPCB daily limit. Dust suppression required.", time: "12 min ago", ack: false, assignedTo: null },
      { id: "OA-003", severity: "Warning",  category: "NO₂",     station: "Highway Junction NH-48",  message: "NO₂ at 95.4 µg/m³ — near CPCB 24h limit of 80 µg/m³.", time: "18 min ago", ack: false, assignedTo: "Monitoring" },
      { id: "OA-004", severity: "Warning",  category: "PM2.5",   station: "Commercial Hub FC Road",  message: "PM2.5 at 84.5 µg/m³ — AQI 165 (Unhealthy). Issuing public advisory.", time: "25 min ago", ack: true,  assignedTo: "PMC Control" },
      { id: "OA-005", severity: "Info",     category: "Device",  station: "School Zone Kothrud",     message: "Station S06 offline for 38 minutes. Last known AQI: 128.", time: "38 min ago", ack: false, assignedTo: null },
    ],

    aiInsights: [
      { id: "AI-OT-01", priority: "High",   icon: "🏭", title: "Industrial Zone — CPCB Violation Predicted", insight: "PM2.5 at 128.4 µg/m³ (24h avg tracking to 95 µg/m³). CPCB limit breach within 6 hours if trend continues. Wind from SW will carry to residential areas.", action: "Alert CPCB" },
      { id: "AI-OT-02", priority: "High",   icon: "🌬", title: "SW Wind Increasing Pollution Spread", insight: "SW wind direction (225°) at 14.5 km/h is transporting industrial emissions to residential zone. Correlated with 85% of high-AQI events. Rain forecast Sunday will clear.", action: "Advisory" },
      { id: "AI-OT-03", priority: "Medium", icon: "🚗", title: "Peak Traffic Pollution — 17:00–19:00", insight: "Highway NH-48 station shows AQI spike to 185–205 during evening rush. Suggest traffic diversion or timing restrictions for heavy vehicles.", action: "Notify PMC" },
      { id: "AI-OT-04", priority: "Medium", icon: "🌧", title: "AQI Relief Expected Sunday", insight: "Weather forecast indicates 22 km/h NW wind + rainfall Sunday. Predicted AQI to drop from 148 to 75–85. Outdoor activities safe from Sunday onwards.", action: "Forecast" },
      { id: "AI-OT-05", priority: "Low",    icon: "📊", title: "Green Belt Air Quality Excellent", insight: "Empress Garden station consistently shows AQI 45–65. Recommend expanding green cover in Commercial Hub to reduce local AQI by an estimated 12–18%.", action: "Report" },
    ],

    reports: [
      { id: "OR-01", name: "Real-Time AQI Bulletin",            desc: "Station-wise live AQI and pollutant status",        generated: "Today 08:00",  formats: ["PDF","CSV"]        },
      { id: "OR-02", name: "CPCB 24-Hour Compliance Report",    desc: "24h average vs NAAQS limits with violation log",    generated: "Today 06:00",  formats: ["PDF","CSV","Excel"] },
      { id: "OR-03", name: "Weekly Ambient Air Quality Report", desc: "7-day AQI trend, station comparison, forecasts",    generated: "Mon 06:00",    formats: ["PDF","Excel"]      },
      { id: "OR-04", name: "Monthly CPCB Submission Report",    desc: "Monthly averages for CPCB portal submission",       generated: "01 Feb 2026",  formats: ["PDF","CSV"]        },
      { id: "OR-05", name: "Pollution Source Analysis",         desc: "Wind correlation, source apportionment analysis",   generated: "25 Feb 2026",  formats: ["PDF","Excel"]      },
      { id: "OR-06", name: "Public Health Advisory Report",     desc: "Plain-language AQI advisory for public display",    generated: "Today 08:00",  formats: ["PDF"]              },
      { id: "OR-07", name: "Station Health & Uptime Report",    desc: "Device uptime, calibration and maintenance log",    generated: "Yesterday",    formats: ["PDF","CSV"]        },
      { id: "OR-08", name: "AQI Forecast Report (48h)",         desc: "AI-powered 48h AQI prediction by station",         generated: "Today 07:00",  formats: ["PDF","CSV"]        },
    ],
  },
};
